import { render, staticRenderFns } from "./Page8.vue?vue&type=template&id=62044e04&scoped=true&"
import script from "./Page8.vue?vue&type=script&lang=js&"
export * from "./Page8.vue?vue&type=script&lang=js&"
import style0 from "./Page8.vue?vue&type=style&index=0&id=62044e04&prod&lang=css&"
import style1 from "./Page8.vue?vue&type=style&index=1&id=62044e04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62044e04",
  null
  
)

export default component.exports